import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import { useNavigate, useParams } from 'react-router-dom';
import CostItemDetails from './CostItemDetails';
import useCostItems from 'hooks/useCostItems';
import { useEffect } from 'react';

const CostItemShow = () => {
	const { id } = useParams();
	const { findCostItem, costItem, isLoading } = useCostItems();
	const navigate = useNavigate();

	const handleEditClick = () => navigate(`/cost-items/${id}/edit`);

	const demoCostItem = {
		name: 'Cost Item 3',
		item: 'Type C',
		coins: 300,
		xp: 150,
		id: 3
	};

	useEffect(() => {
		if (id) findCostItem(id);
	}, [id]);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : costItem?.name}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<CostItemDetails costItem={costItem} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default CostItemShow;
